import React from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { FiCalendar, FiCheck } from 'react-icons/fi';
import { PlayfulContentCard } from '@/components/custom/playful-content-card';
import { cn } from '@/lib/utils';
import { statusBadgeText } from '../utils/BadgeEssay';
import essayIcon from '@/assets/images/icons/essay.png';

// Cores confirmadas: aceitando resposta = info/lighter, em processamento = brand/mission (equivalente ao
// "third" do tema playful, já que --color-third vira ciano no tema lúdico), anulada = danger/lighter,
// correção por IA = success/lighter, prazo encerrado = grey/500. Demais status agrupados por semelhança
// semântica até confirmação.
const STATUS_BADGE_CLASSNAME = {
  accepting_proposal: 'bg-info-light text-info',
  processing: 'bg-mission-light text-mission',
  reviewing: 'bg-mission-light text-mission',
  ocr_review: 'bg-mission-light text-mission',
  sending_by_teacher: 'bg-mission-light text-mission',
  unreviewed: 'bg-success-lightest text-success',
  reviewed: 'bg-success-lightest text-success',
  annulled: 'bg-danger-lighter text-danger',
  annulled_by_teacher: 'bg-danger-lighter text-danger',
  minimum_length_not_satisfied: 'bg-danger-lighter text-danger',
  failed_to_process: 'bg-danger-lighter text-danger',
  close_for_submissions: 'bg-transparent text-neutral-500 shadow-none',
  not_sent: 'bg-transparent text-neutral-500 shadow-none'
};

export function EssayPlayfulCard({ essay }) {
  const navigate = useNavigate();

  const accepting_proposal = essay?.status === 'accepting_proposal';
  const grade = essay?.['essay-student']?.grade ?? 0;

  const meta = [];
  if (accepting_proposal || essay?.status === 'close_for_submissions' || essay?.status === 'ocr_review') {
    meta.push({ icon: FiCalendar, text: `Até ${moment(essay?.['delivery-date']).format('DD/MM/YYYY')}` });
  } else if (['processing', 'annulled', 'annulled_by_teacher'].includes(essay?.status)) {
    meta.push({ icon: FiCalendar, text: `Em ${moment(essay?.['essay-student']?.['delivery-date']).format('DD/MM/YYYY')}` });
    meta.push({ text: `${essay?.['essay-student']?.['submission_order']}° envio` });
  } else if (['reviewed', 'unreviewed', 'reviewing'].includes(essay?.status)) {
    meta.push({ icon: FiCheck, text: `Pontuação ${grade}` });
    meta.push({ text: `${essay?.['essay-student']?.['submission_order']}° envio` });
  }

  const isDisabled = essay?.status === 'close_for_submissions';

  const handleAccess = () => {
    if (['reviewed', 'unreviewed', 'reviewing'].includes(essay?.status)) {
      navigate(`/redacao/consulta/${essay?.id}/${essay?.['essay-student']?.id}`);
    } else if (essay?.status === 'ocr_review') {
      navigate(`/redacao/enviar/${essay?.id}`);
    } else {
      navigate(`/redacao/sobre/${essay?.id}`);
    }
  };

  return (
    <PlayfulContentCard
      icon={essayIcon}
      badge={{ text: statusBadgeText[essay?.status], className: cn('normal-case', STATUS_BADGE_CLASSNAME[essay?.status]) }}
      title={essay?.topic}
      meta={meta}
      actionLabel="Acessar"
      actionDisabled={isDisabled}
      onAction={handleAccess}
      onClick={isDisabled ? undefined : handleAccess}
    />
  );
}
